<template>
  <div class="home">
    <!-- Hero Banner -->
    <Carousel 
      :slides="slides"
      autoPlay
      interval=3000
    />

    <!-- 类别 -->
    <section class="categories-section" v-if="categoryListData.length > 0">
      <div class="categories_cnt">
        <h2 class="section-title sixbottom">{{ t('home.categories.title') }}</h2>
        <h2 class="title_en">popular categories</h2>
        <div class="category-grid">
          <!-- <div class="category-list" :class="{ 'paused': isPaused }" @mouseenter="pauseAnimation" @mouseleave="resumeAnimation"> -->
          <div class="category-list_noscroll">
            <!-- 正常显示的卡片 -->
            <div class="category-card" v-for="category in categoryListData.slice(0, 6)" :key="category.id">
              <router-link :to="getCategoryLink(category)">
                <img class="category-img" :src="imgUrl + category.imageUrl">
                <span>{{ getCategoryName(category.name) }}</span>
              </router-link>
            </div>
            <!-- 克隆的卡片，用于实现首尾相连效果 -->
            <!-- <div class="category-card" v-for="category in categoryListData.slice(0, 6)" :key="category.id + 'clone'">
              <router-link :to="getCategoryLink(category)">
                <img class="category-img" :src="imgUrl + category.imageUrl">
                <span>{{ getCategoryName(category.name) }}</span>
              </router-link>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 热门产品 -->
    <section class="popular">
      <div class="container">
        <div class="title title-flex"><h3>{{ t('home.popular.title') }}</h3><span>popular products</span></div>
        <div class="popular-cont">
          <ProductCard
              v-for="product in displayedHotProducts"
              :key="product.id"
              :id="product.id"
              :price="product.price"
              :originalPrice="product.marketPrice"
              :title="getCategoryName(product.brandName)"
              :brand="getCategoryName(product.skuName)"
              :discount="product.discount"
              :rating="product.rating"
              :reviewCount="product.reviewCount"
              :stock="product.stock"
              :availability="product.availability"
              :imageUrl="imgUrl + product.mainImageFileUrl"
              :favoriteId="product.favoriteId"
              @toggle-favorite="toggleFavorite(product)"
              @quick-View="quickView(product)"
            />
          <!-- <li v-for="item in displayedHotProducts" :key="item.id">
            <router-link :to="{ path: '/purchase', query: { categoryId: item.id } }">
              <img :src="imgUrl + item.mainImageFileUrl" cover="">
              <aside>
                <span>{{ getCategoryName(item.name) }}</span>
                <b>${{ item.price }}</b>
              </aside>
            </router-link>
          </li> -->
        </div>
        <a :class="[showAllItems?'ico-close':'ico-add','popular-more', 'ico']" @click="showAllItems = !showAllItems"></a>
      </div>
    </section>

    <!-- 特别优惠 -->
    <section class="deals-section">
      <div class="container">
        <h2 class="section-title">{{ t('home.deals.title') }}</h2>
        <h2 class="title_en">special offer</h2>
        <div class="deals-container">
          <button class="scroll-btn prev" @click="scrollDeals('left')">
            <font-awesome-icon icon="chevron-left" />
          </button>
          <div class="deals-grid" ref="dealsGrid">
            <ProductCard
              v-for="product in discountProductListData"
              :key="product.id"
              :id="product.id"
              :price="product.price"
              :originalPrice="product.marketPrice"
              :title="getCategoryName(product.brandName)"
              :brand="getCategoryName(product.skuName)"
              :discount="product.discount"
              :rating="product.rating"
              :reviewCount="product.reviewCount"
              :stock="product.stock"
              :availability="product.availability"
              :imageUrl="imgUrl + product.mainImageFileUrl"
              :favoriteId="product.favoriteId"
              @toggle-favorite="toggleFavorite(product)"
              @quick-View="quickView(product)"
            />
            
          </div>
          <button class="scroll-btn next" @click="scrollDeals('right')">
            <font-awesome-icon icon="chevron-right" />
          </button>
        </div>
      </div>
    </section>

    <!-- 我们提供的服务 -->
    <section class="services-section">
      <div class="container">
        <h2 class="services-title">{{ t('home.services.title') }}</h2>
        <div class="services-grid">
          <em>
            <img src="@/assets/imgs/about_comster.png" >
          </em>
          <!-- 服务隐藏 -->
          <ul style="display: none;">
            <li>
              <router-link to="./delivery"><h5>{{ t('home.services.delivery') }}</h5><i class="ico ico-alone-right"></i></router-link>
              <p>{{ t('home.services.deliveryDesc') }}</p>
            </li>
            <li>
              <router-link to="./installation"><h5>{{ t('home.services.installation') }}</h5><i class="ico ico-alone-right"></i></router-link>
              <p>{{ t('home.services.installationDesc') }}</p>
            </li>
            <li>
              <router-link to="./design"><h5>{{ t('home.services.design') }}</h5><i class="ico ico-alone-right"></i></router-link>
              <p>{{ t('home.services.designDesc') }}</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="sever">
      <div class="container">
        <div class="sever-cont">
          <li><i class="ico ico-place-location"></i><span>{{ t('footer.pointToPointService') }}<br>{{ t('footer.highQualityService') }}</span></li>
          <li><i class="ico ico-safety-done"></i><span>{{ t('footer.productCertification') }}<br>{{ t('footer.safeAndReliable') }}</span></li>
          <li><i class="ico ico-card"></i><span>{{ t('footer.multiplePaymentMethods') }}<br>
            <!-- {{ t('footer.crossBorderWorryFree') }} -->
          </span></li>
          <li><i class="ico ico-customer"></i><span>{{ t('footer.24HourOnlineService') }}<br>{{ t('footer.userConvenience') }}</span></li>
        </div>
      </div>
    </section>
    
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Carousel from '@/components/common/Carousel.vue';
import ProductCard from '@/components/common/ProductCard.vue';
import { bannerList } from '@/api/categoryList';
import { onedepartmentList } from '@/api/categoryList';
import { imgUrl } from '@/api/categoryList';
import { hotProductList } from '@/api/categoryList';
import { favoriteAdd, favoriteProductCancel } from '@/api/favorite';
import { ElMessage } from 'element-plus';
const { t, locale } = useI18n();
const router = useRouter();

//热门商品数据
const showAllItems = ref(false);

// 计算属性：根据是否显示全部返回对应的产品列表
const displayedHotProducts = computed(() => {
  return showAllItems.value ? hotProductListData.value : hotProductListData.value.slice(0, 6);
});

const hotProductListParams = {
  "isHot": 1
}

const hotProductListData = ref([])
hotProductList(hotProductListParams).then(res => {
  hotProductListData.value = res.data.records
})
// 优惠商品数据
const discountProductListParams = {
  "isDiscount": 1
}
const discountProductListData = ref([])
hotProductList(discountProductListParams).then(res => {
  discountProductListData.value = res.data.records
})

const bannerListData = ref([])
const params = {
  // "pageNum": 0,
  // "pageSize": 0,
  // "title": "",
  // "linkType": 0,
  // "isActive": 0
}
interface Category {
  id: number;
  name: string;
  imageUrl: string;
}

const categoryListData = ref<Category[]>([])
const categoryParams = {
  "level": 1,
  "type": 1,
} as const

// 获取类别链接
const getCategoryLink = (category: Category) => {
  return `/building-materials?categoryId=${category.id}`;
}

// const { t, locale } = useI18n();监听语言切换事件
const currentLang = computed(() => locale.value === 'en' ? 'en-US' : 'zh-CN');
const updateCurrentLang = async (lang: string) => {
  locale.value = lang === 'en-US' ? 'en' : 'zh'
}
window.addEventListener('languageChange', (event: Event) => {
  const detail = (event as CustomEvent).detail || { lang: 'zh' }
  const newLang = detail.lang
  updateCurrentLang(newLang)
})
const getCategoryName = (name: string) => {
  try {
    const translations = JSON.parse(name)
    return translations[currentLang.value]
  } catch (error) {
    // 如果解析失败，直接返回原始值
    return name
  }
}
// end监听语言切换事件
interface Banner {
  id: number;
  imageUrl: string;
  imageUrlEn: string;
  title: string;
  subTitle: string;
  description: string;
  linkTarget: string;
  linkType: number;
}
const slides = computed(() => {
  return bannerListData.value.map((banner: Banner) => ({
    image: imgUrl + (currentLang.value === 'en-US' ? banner.imageUrlEn || banner.imageUrl : banner.imageUrl),
    title: banner.title,
    subTitle: banner.subTitle,
    description: banner.description,
    buttonText: banner.linkTarget,
    buttonLink: banner.linkType
  }));
});

// 无缝滚动控制
const isPaused = ref(false);
const pauseAnimation = () => {
  isPaused.value = true;
};

const resumeAnimation = () => {
  isPaused.value = false;
};

onMounted(() => {
  bannerList(params).then(res => {
    bannerListData.value = res.data || [];
  }).catch(error => {
    console.error('Failed to fetch banner data:', error);
  });

  onedepartmentList(categoryParams).then(res => {
    categoryListData.value = res.data || [];
  }).catch(error => {
    console.error('Failed to fetch banner data:', error);
  });
});


function addToCart() {
  router.push({ name: 'cate' });
}


// 获取产品
const getProduct = (id: number) => {
  return discountProductListData.value.find(p => p.id === id);
};
const deleteFavoriteId = ref(null)
// 切换收藏状态
const toggleFavorite = async (product: any) => {
  try {
    if (product.favoriteId != null) {
      // 如果favoriteId不为null，执行取消收藏
      if(product.favoriteId != 1){
        deleteFavoriteId.value = product.favoriteId
      }
      const response = await favoriteProductCancel([deleteFavoriteId.value]);
      
      // 更新UI状态 - 更新discountProductListData和displayedHotProducts
      const updateProductInArray = (arr: any[], id: number) => {
        const index = arr.findIndex((p: any) => p.id === id);
        if (index !== -1) {
          arr[index].favoriteId = undefined;
        }
      };
      
      updateProductInArray(discountProductListData.value, product.id);
      updateProductInArray(displayedHotProducts.value, product.id);
      
      ElMessage.success(t('shop.favoriteCancelSuccess'));
    } else {
      // 如果favoriteId为null，执行添加收藏
      console.log('Adding favorite for product:', product.id);
      const response : any = await favoriteAdd({
        shopId: product.shopId,
        productId: product.id,
        skuId: product.skuId,
        favoriteType: 1
      });      
      // 更新UI状态 - 更新discountProductListData和displayedHotProducts
      const updateProductInArray = (arr: any[], id: number, favoriteId: string) => {
        const index = arr.findIndex((p: any) => p.id === id);
        if (index !== -1) {
          arr[index].favoriteId = favoriteId;
        }
      };
      
      const favoriteId = response?.data?.favoriteId || '1';
      updateProductInArray(discountProductListData.value, product.id, favoriteId);
      updateProductInArray(displayedHotProducts.value, product.id, favoriteId);
      deleteFavoriteId.value = response.favoriteId
      ElMessage.success(t('shop.favoriteSuccess'));
    }
  } catch (error) {
    console.error('Error in toggleFavorite:', error);
    if (product.favoriteId != null) {
      ElMessage.error(t('shop.favoriteCancelError'));
    } else {
      ElMessage.error(t('shop.favoriteError'));
    }
  }
}


function quickView(product: any) {
  router.push({ path: 'purchase' ,query: { categoryId: product.id } });
}

// Scroll functionality
const dealsGrid = ref(null);

const scrollDeals = (direction: 'left' | 'right') => {
  const scrollAmount = 1400; // 每次滚动1400px，相当于5个卡片的宽度
  
  if (dealsGrid.value) {
    if (direction === 'left') {
      dealsGrid.value.scrollLeft -= scrollAmount;
    } else {
      dealsGrid.value.scrollLeft += scrollAmount;
    }
  }
}
</script>

<style scoped lang="scss">
// Variables
$primary-color: #fb6e01; // Home Depot orange
$secondary-color: #fb6e01; // Home Depot blue
$light-gray: #f8f9fa;
$dark-gray: #333;
$white: #fff;
$breakpoint-md: 768px;
$breakpoint-sm: 576px;

.home {
  margin: 0;
  padding: 0;
}


// Section styling
.section-title {
  font-size: 28px;
  margin-bottom: 6px;
  text-align: center;
  position: relative;
  
  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 4px;
    background-color: $primary-color;
    margin: 10px auto 0;
  }
}
// Categories section
.categories-section {
  padding: 30px 0;
  background-color: $white;
  
  .categories_cnt {
    width: 100%;
    margin: 0 auto;
    position: relative;
  }
  
  .category-grid {
    width: 100%;
    height: 240px;
    overflow: hidden;
    position: relative;
  }
  .category-list_noscroll {
    display: grid;
    overflow: auto;
    position: relative;
    padding: 0;
    width: auto;
    margin: 0 auto;
    text-align: center;
    align-items: center;
    justify-content: center;
    max-width: 1539px;
    grid-template-columns: repeat(6, 1fr);
    gap: 20px;
  }

  .category-list {
    display: flex;
    animation: classfly 20s infinite linear;
    animation-timing-function: linear;
    animation-delay: 0s;
  }
     
  .category-card {
      min-width: 240px;
      
      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: auto;
        height: 240px;
        color: #333;
        background-color: #f7f7f7;
        border-radius: 0;
        transition: all 0.3s ease;
        
        &:hover {
          color: #fb6e01;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }
        
        .category-img {
          width: 60%;
          height: 60%;
          margin: 10px 0;
          border-radius: 4px;
        }
        
        span {
          display: block;
          font-size: 1rem;
          margin-top: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 500;
        }
      }
    }
  .paused {
    animation-play-state: paused !important;
  }
  
  @keyframes classfly {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(calc(-200px * 6));
    }
  }
}
//热门产品
.popular {
  padding: 0;
  background-color: #ffffff;
}
.title-flex {
    display: flex;
}
.title {
    padding: 50px 0;
    text-align: center;
}
.title-flex h3 {
    flex: initial;
    border-left: 3px #fb6e01 solid;
}
.title h3, .title span {
    font-size: 28px;
    line-height: 28px;
    height: 28px;
    min-width: 0;
    padding: 0 10px;
}
.title h3, .title em {
    display: inline-block;
    vertical-align: middle;
}
.title span, .title_en {
    text-transform: uppercase;
    color: #eee;
    text-align: center;
    display: none;
}
.popular-cont {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
}
.popular-cont li {
    height: 250px;
}
.popular-cont li:first-child {
    grid-row: span 2;
    height: 520px;
}
.popular-cont li a {
    display: block;
    position: relative;
    height: 100%;
    text-align: center;
    overflow: hidden;
}
[cover],.cover {
  width: auto;
}
.popular-cont li a img {
    transition-duration: .3s;
}
.popular-cont li aside {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-image: linear-gradient(transparent, rgba(0,0,0,.5));
  padding: 40px 10px 10px;
  display: flex;
  font-size: 1rem;
}
.popular-cont li aside span {
  flex: 1;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}
.popular-cont li aside b {
  color: #fb6e01;
  font-size: 1.2rem;
}
.popular-more {
    margin: 30px auto 60px;
    display: block;
    font-size: 36px;
    color: #fb6e01;
}
.ico-add:before {
    content: "\e6f3";
}

// Deals section
.deals-section {
  padding: 60px 0;
  background-color: #f7f7f7;
  
  .deals-container {
    position: relative;
    overflow: hidden;
    padding: 0;
  }

  .deals-grid {
    display: flex;
    gap: 20px;
    padding: 0 20px;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    
    /* 隐藏滚动条 */
    &::-webkit-scrollbar {
      display: none;
    }
    
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }

  .product-card {
    width: 291px;
    flex: 0 0 auto;
    scroll-snap-align: start;
  }


  .scroll-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.5);
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    
    &:hover {
      background: $primary-color;
      color: $white;
    }
  }

  .prev {
    left: 0;
  }

  .next {
    right: 0;
  }
}

// Services section
.services-section {
  background-color: #eee;
  background-image: url(@/assets/imgs/about.png);
  background-size: 1300px;
  .services-title {
    text-align: center;
    padding: 50px 0;
    font-size: 50px;
    font-weight: normal;
    letter-spacing: 10px;
  }
  .services-grid {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .services-grid em {
    display: block;
    width: 400px;
  }
  .services-grid ul {
    margin-left: 300px;
    overflow: hidden;
  }
  .services-grid ul li {
    padding: 10px 0;
  }
  .services-grid ul li a {
    display: flex;
    align-items: center;
    color: #fb6e01;
    padding: 20px 0;
  }
  .services-grid ul li a:hover i {
    transform: translateX(10px);
  }
  .services-grid ul li a h5 {
    font-size: 26px;
  }
  .services-grid ul li a i {
    margin: 0 20px;
    font-size: 36px;
    transition-duration: .3s;
  }
  .ico-alone-right:before {
    content: "\e718";
  }
  .services-grid ul li p {
    font-size: 18px;
  }
}

.sever{

  .sever-cont {
    padding: 50px 0;
    display: flex;
  }
  .sever-cont li {
    flex: 1;
    text-align: center;
  }
  .sever-cont li i {
    font-size: 48px;
    color: #fb6e01;
    display: block;
  }
  .ico-place-location:before {
    content: "\e9b1";
  }
  .ico-safety-done:before {
    content: "\e9f0";
  }
  .ico-card:before {
    content: "\e7c4";
  }
  .ico-customer:before {
    content: "\eca9";
  }
}


// Responsive styles
@media (max-width: $breakpoint-md) {
  
  .deals-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  
}

@media (max-width: $breakpoint-sm) {
  .sever-cont{
    display: grid!important;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    width: 100%;
    font-size: 14px;
  }
  .deals-grid {
    grid-template-columns: 1fr !important;
  }
  
  .product-card{
    width: 226px!important;
  }
  .popular-cont .product-card{
    width: auto!important;
  }
  .popular-cont {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 5px;
  }
  .popular-cont li {
    height: 140px;
  }
  .popular-cont li:first-child {
    height: 285px;
  }

  .services-section .services-title {
    padding: 18px 0;
    font-size: 24px;
    letter-spacing: 1px;
  }
  .services-section .services-grid em {
    width: 180px;
  }
  .services-section .services-grid em img {
    width: 100%;
  }
  .services-section .services-grid ul {
    margin-left: 10px;
  }
  .services-section .services-grid ul li a {
    padding: 8px 0;
  }
  .services-section .services-grid ul li a h5 {
    font-size: 18px;
  }
  .services-section .services-grid ul li a i {
    margin: 0 10px;
    font-size: 20px;
  }
  .services-section .services-grid ul li p {
    font-size: 14px;
  }
  .category-list_noscroll {
    justify-content: unset!important;
  }
}
</style>
